import { faSlidersH, faTable } from "@fortawesome/free-solid-svg-icons";
import { INSERT_TABLE_COMMAND } from '@lexical/table';
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalWithFinalForm from "../../../../modals/ModalWithFinalForm";
import { Row } from "reactstrap";
import { useCallback, useState } from "react";
import FormFieldTextOrNumber from "../../../../formFields/FormFieldTextOrNumber";
import { useIntl } from "react-intl";
import { APPLY_RAW_HTML_TABLE_PRESET_COMMAND, PATCH_RAW_HTML_TABLE_CELL_STYLE_COMMAND, PATCH_RAW_HTML_TABLE_STYLE_COMMAND, RawHtmlStylePatch } from "../../../nodes/rawHtmlTable/commands";
import { RawHtmlTableStyle } from "../../../nodes/rawHtmlTable/tableStyle";
import TablePropertiesModal from "./TablePropertiesModal";
import { $getRawHtmlTableSelectionContext, RawHtmlTableSelectionContext } from "../../../nodes/rawHtmlTable/selection";

type TableProperties =
{
    enableRawHtmlTableActions?: boolean
}

const collapsePayload: RawHtmlStylePatch<RawHtmlTableStyle> = { borderCollapse: 'collapse', borderSpacing: '0' };
const separatePayload: RawHtmlStylePatch<RawHtmlTableStyle> = { borderCollapse: 'separate', borderSpacing: '2px' };

export function Table({ enableRawHtmlTableActions }: TableProperties)
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const toolbarTranslations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPropertiesModalOpen, setIsPropertiesModalOpen] = useState(false);
    const [tableSelectionContext, setTableSelectionContext] = useState<RawHtmlTableSelectionContext | null>(null);

    const handleSubmit = (formData: { columns: string, rows: string }) =>
    {
        editor.dispatchCommand(INSERT_TABLE_COMMAND, formData);
        setIsModalOpen(false);
    };

    const handleOpenPropertiesModal = () =>
    {
        let context: RawHtmlTableSelectionContext | null = null;

        editor.getEditorState().read(() => { context = $getRawHtmlTableSelectionContext(); });

        if (!context)
        {
            console.warn('No raw html table selected');
            return;
        }

        setTableSelectionContext(context);
        setIsPropertiesModalOpen(true);
    };

    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.tableModal;
    const buttons =
    {
        confirm: { color: 'success', label: translations?.confirm ?? 'OK' },
        cancel: { color: 'danger', label: translations?.cancel ?? 'Cancel' }
    };
    const element =
    <>
        <div className="btn-group">
            <button type="button" className="btn" onClick={() => setIsModalOpen(true)}>
                <FontAwesomeIcon icon={faTable} />
            </button>

            {enableRawHtmlTableActions &&
                <button
                    type="button"
                    className="btn"
                    title={toolbarTranslations?.tableProperties ?? 'Table properties'}
                    onClick={handleOpenPropertiesModal}
                >
                    <FontAwesomeIcon icon={faSlidersH} />
                </button>
            }
        </div>
        {isModalOpen && <ModalWithFinalForm isOpen={isModalOpen} initialValues={{ columns: 5, rows: 5 }}
            setIsOpen={setIsModalOpen}
            onConfirm={handleSubmit}
            header={translations?.header ?? 'Table'}
            buttons={buttons}
            modalBody=
            {<>
                {/* <Alert color='danger' isOpen={isAlertOpen} toggle={() => setIsAlertOpen(false)} >
                    <span>{alertMessage}</span>
                </Alert> */}
                <Row className='my-2 d-flex flex-column '>
                    <FormFieldTextOrNumber type='number' className="w-100" name='columns' label={translations?.columns ?? 'Columns'} />
                </Row>
                <Row className='my-2'>
                    <FormFieldTextOrNumber type='number' className="w-100" name='rows' label={translations?.rows ?? 'Rows'} />
                </Row>
            </>}
        />}
        {isPropertiesModalOpen &&
            <TablePropertiesModal
                isOpen={isPropertiesModalOpen}
                setIsOpen={setIsPropertiesModalOpen}
                tableSelectionContext={tableSelectionContext}
            />
        }
    </>;
    return element;
}